import { isCidaasSystemUserId } from './cidaas.model';
import { UserCheckAPIRequest } from '../login.interface';
import { appendQueryParams } from '../../helpers/req-helper';

export type LoginMethod = 'USER_NAME' | 'EMAIL' | 'MOBILE';

enum CidaasQueryParams {
  UiLocales = 'ui_locales',

  LoginHint = 'login_hint',
  UserIdHint = 'userIdHint'
}

export interface ProviderRedirectParams {
  login_hint: string | undefined;
  ui_locales: string | undefined;
}

export interface CheckUserRequest {
  requestId: string;
  username: string;
  loginMethod: LoginMethod;
}

export const generateUserCheckRequest = (config: CheckUserRequest): UserCheckAPIRequest => {
  const { requestId, username, loginMethod } = config;

  const options: UserCheckAPIRequest = { requestId };

  if (loginMethod === 'USER_NAME') {
    options.username = username;
  } else {
    if (isCidaasSystemUserId(loginMethod)) {
      options[loginMethod.toLowerCase()] = username;
    } else {
      options.customFields = {
        [loginMethod]: username,
      };
    }
  }
  return options;
};


export const getUILocaleFromParam = (params: {[key: string]: string}): string | undefined => {
  return params[CidaasQueryParams.UiLocales];
};

export const mapQueryParamsToProviderRedirectParams
  = (params: {[key: string]: string}): ProviderRedirectParams => {
  return {
    ui_locales: params[CidaasQueryParams.UiLocales],
    login_hint: params[CidaasQueryParams.LoginHint] || params[CidaasQueryParams.UserIdHint]
  };
};

export const getProviderRedirectUrl = (redirectUri: string, params: ProviderRedirectParams): string => {
  const url = new URL(redirectUri);
  const searchParams = new URLSearchParams();
  if (params.ui_locales){
    searchParams.set(CidaasQueryParams.UiLocales, params.ui_locales);
  }
  const userName = params.login_hint;
  if (userName){
    searchParams.set(CidaasQueryParams.LoginHint, userName);
  }
  return appendQueryParams(url, searchParams).toString();
};
